jQuery( function ( $ ) {

  $( 'section.posts_slider' ).each( function () {

    const $section = $(this);
    const $slider = $( '.slider', $section );
    const $slider_col = $( '.slider-col', $section );

    $( "a[tabindex='-1'", $slider ).attr( 'data-tabindex', -1 );

    $slider.on( 'beforeChange', function () {
      $slider_col.addClass( 'sliding' );
    });

    $slider.on( 'init afterChange', function ( e, slick, index = null ) {
      // slick calls a11y functionality before afterChange
      // we want to remove the slide's tabindex, so we need to disable the a11y option and call it's core function ourselves
      slick.initADA();
      slick.$slides.filter( '.slick-active' ).removeAttr( 'tabindex' ).find( "[data-tabindex=-1]" ).attr( 'tabindex', -1 );
      slick.$dots.find( 'button' ).removeAttr( 'tabindex' );
      slick.$prevArrow.add( slick.$nextArrow ).each( function () {
        $(this).attr( 'disabled', $(this).hasClass( 'slick-disabled' ) ).removeAttr( 'aria-disabled' );
      });
      $slider_col.removeClass( 'sliding' );
    });

    $slider.slick({
      infinite: false,
      dots: true,
      appendDots: $( '.dots-wrap', $section ),
      customPaging: function ( slider, i ) {
        return $('<button>').html( $( '<span>' ).addClass( 'sr-only' ).text( i + 1 ) );
      },
      arrows: true,
      prevArrow: $( '.prev-btn', $section ),
      nextArrow: $( '.next-btn', $section ),
      accessibility: false,
      mobileFirst: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      rows: 0,
      responsive: [
        {
          breakpoint: ThemeJS.Variables.Screen_Sizes.sm,
          settings: {
            slidesToShow: 2,
          }
        },
      ]
    });

  });

});